import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

// sem perfil = qualquer autenticado | "operador" = operador+admin | "admin" = admin only
const HIERARQUIA = { admin: 3, operador: 2, consulta: 1 };

export default function PrivateRoute({ children, perfil }) {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (perfil && HIERARQUIA[user.perfil] < HIERARQUIA[perfil]) return <Navigate to="/dashboard" replace />;

  return children;
}
